import { Button, Input, Spin, message } from "antd";
import arrowDown from "../../../assets/forgot-password/arrow_down.svg";
import "./style.scss";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { SignInApi } from "../../../apis/SignIn";
import Password from "antd/es/input/Password";
// import { LoadingOutlined } from '@ant-design/icons';
import verifyIcon from "../../../assets/forgot-password/verify_icon.svg";

const ForgotPassword = () => {
  const [formData, setFormData] = useState();
  const [isShowOtp, setIsShowOtp] = useState(false);
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [isShowPassword, setIsShowPassword] = useState(false);
  const [verifiedOtpToken, setVerifiedToken] = useState("");
  const [isButtoDisable, setIsButtonDisable] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const [errorPassword, setErrorPassword] = useState("");
  const [errorNewPassword, setErrorNewPassword] = useState("");
  const [errorConfirmPassword, setErrorConfirmPassword] = useState("");
  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}$/;

  let navigate = useNavigate();
  const handleChange = (e) => {
    if (e.target.name == "email") {
      setIsOtpVerified(false);
      setIsShowOtp(false);
      setIsShowPassword(false);
      setErrorMsg("");
    }
    if (e.target.name == "newPassword") {
      if (!passwordRegex.test(e.target.value)) {
        setErrorNewPassword(
          "At least 1 uppercase, 1 lowercase, 1 number, 1 special character is required with minimum 8 length long"
        );
      } else {
        setErrorNewPassword(""); // Clear the error message
      }
    }
    if (e.target.name == "confirmPassword") {
      if (!passwordRegex.test(e.target.value)) {
        setErrorConfirmPassword(
          "At least 1 uppercase, 1 lowercase, 1 number, 1 special character is required with minimum 8 length long"
        );
      } else {
        setErrorConfirmPassword(""); // Clear the error message
      }
    }
    setIsButtonDisable(false);
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const generateOtp = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (!formData?.email.trim()) {
      message.error("Please enter an email");
      return;
    }
    if (!emailRegex.test(formData?.email)) {
      setErrorMsg("Please enter correct email");
      return;
    }
    try {
      const result = await SignInApi.generateResetPasswordOtp(formData);
      if (result?.status === 200) {
        setIsShowOtp(true);
        setLoading(false);
        setIsButtonDisable(true);
      }
      if (result?.response?.status === 400) {
        setLoading(false);
        message.error(
          result.response.data.message || "Please try again later."
        );
      }
    } catch (err) {
      setLoading(false);
      let error = JSON.parse(err.response.data);
      message.error(error.error || "Please try again later.");
    }
  };
  const verifyOtp = async (e) => {
    e.preventDefault();
    if (!formData?.otp.trim()) {
      message.error("Please enter otp");
      return;
    }
    setLoading(true);
    try {
      formData.distributorId = "663b39b3ab4ec46c6ebcf258";
      const result = await SignInApi.verifyResetPasswordOtp(formData);
      if (result?.status === 200) {
        if (result?.data?.otpVerified) {
          setIsOtpVerified(true);
          setLoading(false);
          setVerifiedToken(result.data.token);
          setTimeout(() => {
            setIsOtpVerified(false);
            setIsShowPassword(true);
            setIsButtonDisable(true);
            setIsShowOtp(false);
          }, 2000);
        } else {
          message.error(result?.data?.reason);
          setLoading(false);
        }
      }
      if (result?.response?.status === 400) {
        setLoading(false);
        message.error(
          result.response.data.message || "Please try again later."
        );
      }
    } catch (err) {
      setLoading(false);
      message.error(err.response.data || "Please try again later.");
    }
  };
  const resetPassword = async (e) => {
    e.preventDefault();
    const regex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}$/;
    if (!regex.test(formData?.newPassword)) {
      setErrorNewPassword(
        "At least 1 uppercase, 1 lowercase, 1 number, 1 special character is required with minimum 8 length long"
      );
      return;
    }

    if (formData?.newPassword !== formData?.confirmPassword) {
      return;
    }
    try {
      formData.token = verifiedOtpToken;
      delete formData.confirmPassword;
      delete formData.otp;
      delete formData.distributorId;
      const result = await SignInApi.resetPassword(formData);
      if (result?.status === 200) {
        message.success("Password Reset Successfully");

        setTimeout(() => {
          navigate("/login");
        }, 1000);
      }
      if (result?.response?.status === 400) {
        message.error(
          result.response.data.message || "Please try again later."
        );
      }
    } catch (err) {
      console.log(err);
      message.error(err.response.data || "Please try again later.");
    }
  };

  const getResetPasswordForm = () => {
    return (
      <>
        <div className="user_email">
          <Input
            type="email"
            id="email"
            name="email"
            placeholder="Your email"
            required
            className="email_input"
            onChange={handleChange}
            onPressEnter={generateOtp}
          />
          <div className="error">{errorMsg}</div>
        </div>
        {isShowOtp && (
          <>
            <span className="verification_text">
              Verification code sent to your email id
            </span>
            <div className="user_otp">
              <Input
                name="otp"
                placeholder="Verification Code"
                required
                className="otp_input"
                onChange={handleChange}
                value={formData?.otp}
                onPressEnter={verifyOtp}
              />
              {isOtpVerified && (
                <div className="verified">
                  <p>
                    Verified
                    <img src={verifyIcon} alt="" />
                  </p>
                </div>
              )}
              {/* <div className="otp_info">
            <div className="wrong_otp">
              Wrong OTP <span>Resend</span>
            </div>
            <div className="wrong_otp">
              Did not receive OTP <span>Resend</span>
            </div>
          </div> */}
            </div>
          </>
        )}
        {isShowPassword && (
          <>
            <div className="user_password">
              <Input.Password
                placeholder="Enter new Password"
                required
                className="password_input"
                name="newPassword"
                onChange={handleChange}
                value={formData?.newPassword}
              />
              {errorNewPassword && (
                <div className="error">{errorNewPassword}</div>
              )}
            </div>
            <div className="user_password">
              <Input.Password
                placeholder="Re-enter new Password"
                required
                className="password_input"
                name="confirmPassword"
                onChange={handleChange}
                value={formData?.confirmPassword}
                onPressEnter={
                  formData?.newPassword == formData?.confirmPassword &&
                  resetPassword
                }
              />
              {formData?.newPassword !== formData?.confirmPassword && (
                <div className="error">Password do not match</div>
              )}
            </div>
          </>
        )}
        <div className="continue_btn_line">
          <Button
            className={`continue_btn ${isButtoDisable ? "disable_btn" : ""}`}
            disabled={isButtoDisable}
            onClick={
              isShowOtp
                ? verifyOtp
                : isShowPassword
                ? resetPassword
                : generateOtp
            }
          >
            <p> Continue </p>
            {/* {loading ? (
              <div className="spinner">
                <Spin
                  indicator={
                    <LoadingOutlined
                      style={{
                        fontSize: 24,
                        color: 'white',
                        marginLeft: '20px',
                      }}
                      spin
                    />
                  }
                />
              </div>
            ) : (
              ''
            )} */}
          </Button>
        </div>
      </>
    );
  };
  return (
    <div className="forgot_wrapper">
      <div className="forgot_section">
        <div className="direction_line_1">Forgot Password?</div>
        <div className="direction_line_3">Enter the email id you used</div>
        {getResetPasswordForm()}
        <div className="back_to_login">
          <Link to="/login">
            <img src={arrowDown} alt="" />
            Back to login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
